import api from "../../../services/api";


export interface InventoryAnalysisParams {
  source?: "shopify" | "Wholesale" | "both";
  threshold_days_OS?: number;
  inv_type?: "OH" | "OO";
  days_look?: number;
}

export const fetchInventoryAnalysis = async (params: InventoryAnalysisParams = {}) => {
  const { data } = await api.get("/api/search_by_inventory", { params });
  return data;
};
